module.exports = __webpack_public_path__ + "media/walking-mobile.cad3feca.mp4";